import { useMutation } from '@hooks/reactQuery';

import { getGoldenSettingsMavenirConfigTree } from '@api/goldenSettings';

import { createSettledPathHandler } from '@components/routes/CmModule/ConfigurationComparison/MOTreeMavenir/utils';

import { TGoldenSettingsConfigTreeDTO } from '@interfaces/cmModule/dto/goldenSettingsDTO';
import { IGoldenSettingsTree } from '@interfaces/cmModule/goldenSettings';
import {
	IMavenirSelectChangeCallback,
} from '@components/routes/CmModule/ConfigurationComparison/MOTreeMavenir/FlatTreeMavenir/interfaces';

import { GOLDEN_SETTING_TREE_BY_PATH } from '@constants/queryKeys';

const useMutateGoldenSettingsByPath = (
	params: Partial<TGoldenSettingsConfigTreeDTO>,
) => {
	const {
		vendor,
		dateText,
		version,
		nodes,
		type,
		importId,
	} = params || {};

	const isInstalledWithParams = vendor && dateText && nodes && type && version || importId;

	const {
		isLoading,
		mutateAsync: getConfigForPath,
	} = useMutation<TGoldenSettingsConfigTreeDTO, IGoldenSettingsTree>({
		mutationKey: [GOLDEN_SETTING_TREE_BY_PATH],
		mutationFn: async ({ path, node, setData }: IMavenirSelectChangeCallback) => {
			if (!isInstalledWithParams && !path) {
				return;
			}

			const data = await getGoldenSettingsMavenirConfigTree({
				dateText: dateText!,
				nodes: nodes!,
				path: path,
				type: type!,
				version: version!,
				vendor: vendor!,
				importId: importId!,
			});

			createSettledPathHandler({ data, setData, node });
		},
	});

	return {
		getConfigForPath,
		isLoadingGetConfigForPath: isLoading,
	};
};

export default useMutateGoldenSettingsByPath;
